import i18next from 'i18next';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
  comment: Yup.string(),
  value: Yup.string().required(i18next.t('validation.common.required')),
  factorType: Yup.string().required(i18next.t('validation.common.required')),
  grades: Yup.array().of(Yup.number().required(i18next.t('validation.common.required'))),
});
